import { render, staticRenderFns } from "./Qna.vue?vue&type=template&id=44f6236e&scoped=true&"
import script from "./Qna.vue?vue&type=script&lang=js&"
export * from "./Qna.vue?vue&type=script&lang=js&"
import style0 from "./Qna.vue?vue&type=style&index=0&id=44f6236e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f6236e",
  null
  
)

export default component.exports